import { handleActions } from 'redux-actions'

import { initialState, SigningState } from './model'
import { Payload } from '../../../types'
import { prepareActions } from '../../../utils'

const actionsNames = [
  'clearSigningState',
  'sendFirstSms',
  'sendSms',
  'smsSent',
  'setSigningType',
  'setVerificationCode',
  'submitCode',
]

interface Actions {
  clearSigningState: any
  sendFirstSms: any
  sendSms: any
  smsSent: any
  setSigningType: any
  setVerificationCode: any
  submitCode: any
}

export const actions: Actions = prepareActions(actionsNames, 'signing') as Actions

export default handleActions<SigningState, Payload>(
  {
    [actions.clearSigningState]: (): SigningState => initialState,
    [actions.setSigningType]: (state: SigningState, action): SigningState =>
      state.set('type', action.payload),
    [actions.sendFirstSms]: (state: SigningState): SigningState =>
      state.set('didSendFirstSms', true),
    [actions.smsSent]: (state: SigningState, action: any): SigningState =>
      state.set('smsSendResponse', action.payload).set('verificationCode', undefined),
    [actions.setVerificationCode]: (state: SigningState, action): SigningState =>
      state.set('verificationCode', action.payload),
  },
  initialState
)
